module.exports = __webpack_public_path__ + "img/sob.d7034931.png";